import { Widget } from "@typeform/embed-react";

const Form = ({ id }) => {
  return <Widget id={id} className="w-full h-full" />;
};

export default Form;
